import type { TFunction } from 'i18next';

/** Champs possibles sur la company Redux / API pour le palier d’abonnement */
export type CompanyPlanFields = { plan?: string; status?: string } | null | undefined;

/**
 * Code brut du plan : `plan` (crédits Stripe) prioritaire, sinon `status` (legacy / autres APIs).
 */
export function resolveSubscriptionPlanCode(c: CompanyPlanFields): string | undefined {
    const raw = String(c?.plan || c?.status || '').trim();
    return raw || undefined;
}

export function planLabelFromCompany(t: TFunction, c: CompanyPlanFields): string {
    const code = resolveSubscriptionPlanCode(c);
    if (!code) return t('layout.header.planUnknown');
    const s = code.toUpperCase();
    const keys: Record<string, string> = {
        FREE: 'layout.header.planFREE',
        ESSENTIAL: 'layout.header.planESSENTIAL',
        PLUS: 'layout.header.planPLUS',
        ENTERPRISE: 'layout.header.planENTERPRISE',
    };
    const key = keys[s];
    if (key) return t(key);
    return s.charAt(0) + s.slice(1).toLowerCase();
}
